import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import atom from '@tencent/vft-atom';
import login from '@tencent/vft-common/login';
import env from '@tencent/vft-common/env';
import { getPayVipFromNetwork } from "./util";
import { createMutation } from "./helper";
var isDev = process.env.NODE_ENV === 'development';
var initResolve;
var initPromise = new Promise(function (resolve) {
  initResolve = resolve;
});
export default {
  plugins: [],
  state: function state() {
    return {
      isInit: false,
      isLogin: false,
      userInfo: null,
      payVip: null,
      initPromise: initPromise
    };
  },
  mutations: _objectSpread({}, createMutation(['isInit', 'isLogin', 'userInfo', 'payVip'])),
  actions: {
    init: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var commit,
            dispatch,
            state,
            _ref2,
            _ref2$getUserInfo,
            getUserInfo,
            _ref2$getPayVip,
            getPayVip,
            _ref2$useNetwork,
            useNetwork,
            isLogin,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, dispatch = _ref.dispatch, state = _ref.state;
                _ref2 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref2$getUserInfo = _ref2.getUserInfo, getUserInfo = _ref2$getUserInfo === void 0 ? true : _ref2$getUserInfo, _ref2$getPayVip = _ref2.getPayVip, getPayVip = _ref2$getPayVip === void 0 ? true : _ref2$getPayVip, _ref2$useNetwork = _ref2.useNetwork, useNetwork = _ref2$useNetwork === void 0 ? false : _ref2$useNetwork;

                if (env.isApp) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return new Promise(function (resolve) {
                  login.init(resolve);
                });

              case 5:
                isLogin = login.isLogin();
                commit('saveIsLogin', isLogin);

                if (!isLogin) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return Promise.all([getUserInfo ? dispatch('getUserInfo') : undefined, getPayVip ? dispatch('getPayVip', {
                  useNetwork: useNetwork
                }) : undefined]);

              case 10:
                commit('saveIsInit', true);
                initResolve(true);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }(),
    getUserInfo: function () {
      var _getUserInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
        var commit, state, userInfo, oldVal, newVal;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref3.commit, state = _ref3.state;
                _context2.next = 3;
                return atom.getMainUserInfo();

              case 3:
                userInfo = _context2.sent;
                oldVal = state.userInfo;
                newVal = userInfo;

                if (userInfo) {
                  if (!oldVal) {
                    commit('saveUserInfo', userInfo);
                  } else if (oldVal.type !== newVal.type || oldVal.id !== newVal.id) {
                    commit('saveUserInfo', userInfo);
                  }
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getUserInfo(_x2) {
        return _getUserInfo.apply(this, arguments);
      }

      return getUserInfo;
    }(),
    getPayVip: function () {
      var _getPayVip = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref4) {
        var commit,
            _ref5,
            _ref5$useNetwork,
            useNetwork,
            payVip,
            _args3 = arguments;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref4.commit;
                _ref5 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, _ref5$useNetwork = _ref5.useNetwork, useNetwork = _ref5$useNetwork === void 0 ? false : _ref5$useNetwork;
                _context3.next = 4;
                return isDev || useNetwork ? getPayVipFromNetwork() : atom.getPayVip();

              case 4:
                payVip = _context3.sent;
                commit('savePayVip', payVip);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getPayVip(_x3) {
        return _getPayVip.apply(this, arguments);
      }

      return getPayVip;
    }()
  }
};